
export const styles = theme => ({
  plantPlx: {
    display: "flex",
    justifyContent: "center",
    transform: "translateY(-50vh) scale(0.5)",
  },
  plant: {
    width: "40vw",
  },
  stemPlx: {
    opacity: 0,
    backgroundColor: "#b5b3b35e",
    padding: 20,
  },
  podsPlx: {
    opacity: 0,
    backgroundColor: "#b5b3b35e",
    padding: 20,
  },
});


export const plantAnim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 1),
    end: viewHeight * (screen),
    properties: [
      {
        startValue: 0.5,
        endValue: 1,
        property: "scale",
      },
      {
        startValue: viewHeight * -0.5,
        endValue: 0,
        property: "translateY",
      },
    ],
  },
]);

export const stemAnim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 0.7),
    end: viewHeight * (screen - 0.5),
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
      {
        startValue: -200,
        endValue: 0,
        property: "translateX",
      },
    ],
  },
]);

export const podsAnim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 0.5),
    end: viewHeight * (screen - 0.2),
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
      {
        startValue: 200,
        endValue: 0,
        property: "translateX",
      },
    ],
  },
]);